// extracted by mini-css-extract-plugin
export default {"stosks_column":"styles_stosks_column__kz0XF","link_download":"styles_link_download__etXuP","text_time":"styles_text_time__6PThW"};